/*
 * patient-fax (schema)
 */
import { boolean, numeric, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { users } from "../user/user.schema"

// status: pending → sending → delivered | failed | cancelled
export const FAX_STATUSES = ["pending", "sending", "delivered", "failed", "cancelled"] as const
export type FaxStatus = (typeof FAX_STATUSES)[number]

export const patientFaxes = schema.table("patient_faxes", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),
	fileAttachmentIds: uuid("file_attachment_ids").array(),

	// --- Recipient ---
	recipientName: varchar("recipient_name", { length: 256 }),
	recipientFaxNumber: varchar("recipient_fax_number", { length: 32 }).notNull(),

	// --- Content ---
	subject: varchar("subject", { length: 512 }),

	// --- Phaxio ---
	status: varchar("status", { length: 32 }).notNull().default("pending"),
	phaxioFaxId: varchar("phaxio_fax_id", { length: 128 }),
	cost: numeric("cost", { precision: 8, scale: 4 }),
	errorMessage: text("error_message"),
	sentAt: timestamp("sent_at", { withTimezone: true }),
	deliveredAt: timestamp("delivered_at", { withTimezone: true }),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
